/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_WeightInputs */

const en_us2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log weight`)
};

const pt_br2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar peso`)
};

const es_419_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar peso`)
};

const pt_pt2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar peso`)
};

const fr_fr2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noter mon poids`)
};

const de_de2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht eintragen`)
};

const it_it2_search_action_weight = /** @type {(inputs: Search_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra il peso`)
};

/**
* | output |
* | --- |
* | "Log weight" |
*
* @param {Search_Action_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_weight = /** @type {((inputs?: Search_Action_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_weight(inputs)
	if (locale === "es-419") return es_419_search_action_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_weight(inputs)
	if (locale === "de-DE") return de_de2_search_action_weight(inputs)
	if (locale === "it-IT") return it_it2_search_action_weight(inputs)
	return en_us2_search_action_weight(inputs)
});
export { search_action_weight as "search.action_weight" }